import React, { useContext, useEffect, useState } from "react";
import { MyContext } from "../../../context/MyContext";
import ProgressBar from "../../../components/ProgressBar";
import SelectBox from "../../../components/SelectBox";

// icons
import Send from '../../../assets/icons/icon_send.png';
import Bottom from '../../../assets/icons/icon_bottom.png';
import { backIncstance, getLoginInfo } from "../../../utils/commonFunctions";
import { useNavigate } from "react-router-dom";
import BasicSpeech from "../BasicSpeech";

const URLS = {
  PROMPT_MSG: process.env.REACT_APP_PROMPT,
  PERSONA: process.env.REACT_APP_SETTINGS_GET_PERSONA_LIST,
}
// text
const TEXT = process.env.REACT_APP_WARN_TEXT;

const Input = props => {

  const { user, clearState, setAlertSetting } = useContext(MyContext)

  const navigation = useNavigate()
  const [prompt, setPrompt] = useState('')
  const [persona, setPersona] = useState([])
  const { timer, setIsVoiceMode, setTextFunction, searchRef, fetching, isFocus, history, isStartInterview, handleStartInterview, handleResizeHeight, checkKeyType, isFreeScroll, countLeftTime, setIsFocus, setIsLogin, isUpdate, setIsUpdate, isNewTime, setIsNewTime, isFinish, inputRef, handleSubmitQuestion, handleSelect, fetchData, setIsOpenTicketAlert } = props;
  // 240627 로그인 정보 가져오기
  const loginInfo = getLoginInfo();

  const handleLinkToProducts = e => {
    e.preventDefault()
    setIsOpenTicketAlert(true)
    return
  }

  const touchAPI = async (method, url, data) => {
    try {
      const response = await backIncstance(method, url, data)
      const resData = await response?.json()

      if (!resData) return
      if (url.includes(URLS.PROMPT_MSG)) {
        setPrompt(resData.content)
      } else if (url.includes(URLS.PERSONA)) {
        const data = resData.persona_list;
        const copy = data?.map(item => ({
          label: item.tone,
          value: item.tone,
        }));
        setPersona(copy)
      }

    } catch (err) {
      setAlertSetting(prev => ({
        ...prev,
        alertTxt: `서버 오류입니다.\n관리자에게 문의 바랍니다.`,
        btnTxt: '닫기'
      }));
    } finally {
    }

  }
  useEffect(() => {
    const url = `${URLS.PROMPT_MSG}?kind=socra`
    touchAPI('GET', url)
    touchAPI('GET', URLS.PERSONA)
  }, [])

  const saveVoiceRecord = (e) => {
    if (e !== '') {
      inputRef.current.value = e
    }
  }


  const handleVoiceInput = e => {
    if (inputRef?.current?.value) {
      setIsVoiceMode(true);
      // inputRef.current.value = ""
      // fetchData(URLS.CLARIO, 'auto', inputRef.current.value)
    }
  }

  return (
    <div className="inp-wrp" >
      {
        (isNewTime && history.length > 0 && !fetching) &&
        <ProgressBar
          time={timer}
          handleTimer={() => setIsNewTime(false)}
          onFinish={(e) => countLeftTime(e)}
        />
      }
      <div className={`inp-wrp__box ${isFocus ? 'focus' : ''}`}>

        <form className="inp-wrp__box__form" onSubmit={handleSubmitQuestion}>
          <textarea
            placeholder={prompt}
            name="user-input"
            ref={inputRef}
            disabled={!isStartInterview}
            readOnly={fetching}
            // todo 주석 해제
            // onFocus={(e) => (loginInfo?.id || user.id) ? setIsFocus(true) : setIsLogin(true)}
            // onFocus={() => user.id ? setIsFocus(true) : setIsLogin(true)}
            onBlur={() => setIsFocus(false)}
            rows={1}
            onChange={handleResizeHeight}
            onKeyDown={checkKeyType}
          />
          {
            inputRef.current &&
            // <VoiceRecognition  setInput={saveVoiceRecord} onFinish={handleVoiceInput} />
            <BasicSpeech ref={searchRef} setTextFunction={setTextFunction} />
          }
          <button type="submit" id="sbm-btn" style={{ display: 'none' }} />
          <label htmlFor="sbm-btn"><img src={Send} alt="send-btn" className="sb-btn crs-btn" style={{ width: '23px', padding: '9px' }} /></label>
        </form>
      </div>
      {
        (history.length !== 0 && !isFinish && !isStartInterview) &&
        <div
          style={{ top: '-12%' }}
          className="trigger-btn flex flex-col md:flex-row"
          onClick={handleStartInterview}>
          <button className="positive-btn mb-1 md:mb-0" id="start">이어서 시작</button>
          <button className="negative-btn" id="restart">처음부터 시작</button>
        </div>
      }
      {
        (history.length !== 0 && !isFinish && isStartInterview && !fetching) ?
          <div
            style={{ top: '-50%' }}
            className="trigger-btn"
            onClick={handleStartInterview}>
            <button className="positive-btn" id="stop">면접 중단</button>
          </div>
          :
          (isFreeScroll && history.length !== 0 && isStartInterview && !isFinish) ?
            <div
              style={{
                right: '-10%',
                top: '50%'
              }}
              className="move-to-below crs-btn" id="below-btn" name="below-btn" onClick={() => setIsUpdate(!isUpdate)}>
              <img

                src={Bottom} alt="move-to-bottom" />
            </div>
            :
            null
      }
      <div className="ptn-lb">
        <div className="flx-box sep-elm">
          <div className="left">
            <p className="input_wrp__box__lb">{TEXT}</p>
          </div>
          <div className="right flx-box">
            <SelectBox onlyTxt placeholder='페르소나정의' defaultValue={persona?.find(option => option.value === user.tone)} paint options={persona} mainColor='#E8E5E1' subColor='rgba(83, 40, 223, 1)' emptyColor='rgba(83, 40, 223, 1)' handleChange={handleSelect} />
          </div>
        </div>
        <div className="flx-box input_wrp__ft-lb"><p>AI Service</p> <p>with NAVER Cloud</p></div>

      </div>


    </div >
  )
}
export default Input
